import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './ArticlesPage.css';
import { WP_API_URL } from '../config';

function ArticlesPage() {
    const navigate = useNavigate();
    const [articles, setArticles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filter, setFilter] = useState('all');

    useEffect(() => {
        loadArticles();
    }, []);

    const loadArticles = async () => {
        try {
            const response = await fetch(`${WP_API_URL}/posts?_embed`);
            const data = await response.json();
            setArticles(data);
            setLoading(false);
        } catch (error) {
            console.error('Erreur:', error);
            setLoading(false);
        }
    };

    const getFeaturedImage = (article) => {
        try {
            return article._embedded['wp:featuredmedia'][0].source_url;
        } catch {
            return null;
        }
    };

    const filteredArticles = articles.filter(article => {
        if (filter === 'gratuit') return !article.is_premium;
        if (filter === 'premium') return article.is_premium;
        return true;
    });

    if (loading) {
        return (
            <div className="articles-page">
                <div className="loading">
                    <div className="spinner"></div>
                    <p>Chargement...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="articles-page">
            <div className="articles-header">
                <h1>📄 Articles</h1>
                <p>Contenu exclusif et analyses approfondies</p>
            </div>

            <div className="articles-filters">
                <button
                    className={`filter-btn ${filter === 'all' ? 'active' : ''}`}
                    onClick={() => setFilter('all')}
                >
                    Tous ({articles.length})
                </button>
                <button
                    className={`filter-btn ${filter === 'gratuit' ? 'active' : ''}`}
                    onClick={() => setFilter('gratuit')}
                >
                    🎁 Gratuits
                </button>
                <button
                    className={`filter-btn ${filter === 'premium' ? 'active' : ''}`}
                    onClick={() => setFilter('premium')}
                >
                    💎 Premium
                </button>
            </div>

            <div className="articles-grid">
                {filteredArticles.map(article => {
                    const image = getFeaturedImage(article);
                    return (
                        <div key={article.id} className="article-card" onClick={() => navigate(`/article/${article.id}`)}>
                            <div className="article-image">
                                {image ? (
                                    <img src={image} alt={article.title.rendered} />
                                ) : (
                                    <div className="placeholder">📄</div>
                                )}
                                {article.is_premium ? (
                                    <span className="badge-premium">💎 PREMIUM</span>
                                ) : (
                                    <span className="badge-gratuit">🎁 GRATUIT</span>
                                )}
                            </div>
                            <div className="article-content">
                                <h3 dangerouslySetInnerHTML={{ __html: article.title.rendered }} />
                                <div
                                    className="article-excerpt"
                                    dangerouslySetInnerHTML={{ __html: article.excerpt.rendered }}
                                />
                                <div className="article-footer">
                                    {article.is_premium ? (
                                        <span className="prix">
                                            {article.prix_article
                                                ? `${parseInt(article.prix_article).toLocaleString()} FCFA`
                                                : 'Réservé aux abonnés'}
                                        </span>
                                    ) : (
                                        <span className="gratuit">GRATUIT</span>
                                    )}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default ArticlesPage;